// extracted by mini-css-extract-plugin
export var heroWrapper = "HeroRight-module--heroWrapper--TwsSI";
export var heroImageWrapper = "HeroRight-module--heroImageWrapper--3jM-G";
export var headingWrapper = "HeroRight-module--headingWrapper--1ejTP";
export var descriptionWrapper = "HeroRight-module--descriptionWrapper--3J-Fb";
export var heroLangSelect = "HeroRight-module--heroLangSelect--hjE58";